import React from "react";
import { IconType } from "react-icons";

interface ViewCardProps {
  title: string;
  Icon: IconType;
  value: number;
}

// function ViewCard({ title, Icon, value }: ViewCardProps) {
//   return (
//     <div className="flex flex-col text-white p-4 mobile:p-1 mobile:items-center">
//       <p className="font-bold text-2xl text-white ml-2">{value}</p>
//       <Icon className="text-[#E9BE50] w-8 h-8" />
//       <p className="whitespace-nowrap text-sm">{title}</p>
//     </div>
//   );
// }
function ViewCard({ title, Icon, value }: ViewCardProps) {
  return (
    <div className="flex items-center gap-3 text-white mobile:flex-col mobile:items-start 
    tablet:flex-col tablet:items-start">
      <Icon className="w-6 h-6 mobile:w-5 mobile:h-5 tablet:w-6 tablet:h-6 opacity-80" />

      <div className="flex flex-col">
        <span className="text-2xl mobile:text-lg tablet:text-xl font-semibold">{value}</span>
        <span className="text-sm mobile:text-[11px] tablet:text-sm text-white/80 whitespace-nowrap">
          {title}
        </span>
      </div>
    </div>
  );
}
export default ViewCard;
